


















import { Component, Prop, Vue } from 'vue-property-decorator';
import isDisabledDate from './../../../helpers/isDisabledDate.helpers';
import moment from 'moment';
@Component({
  components: {},
   data: () => ({
    disabledDates: (date: any) => {
       const park = (window as any).park;
       const bookings = (window as any).bookings;
       const user = ((window as any).user);
       const clientType =(window as any).clientType;
        return isDisabledDate(date, park, bookings, user, clientType);
    },
  }),
})
export default class InputBookingDate extends Vue {

    @Prop()
    public mdIcon!: string;

    @Prop()
    public placeholder!: string;

    public date: Date = new Date();

    private mounted(){
      (this as any).$material.locale.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
      (this as any).$material.locale.shortDays =  ['Dom', 'Lun', 'Mar', 'Mier', 'Juev', 'Vier', 'Sab'];
      (this as any).$material.locale.shorterDays = ['D', 'L', 'M', 'I', 'J', 'V', 'S'];
      (this as any).$material.locale.months = ['Enero', 'Martes', 'Miercoles', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    }

    public get placeholderFormated(): string {
      return moment(this.placeholder, 'DDMMYYYY').format('DD/MM/YYYY');
    }
    public onChange($event){
      setTimeout(() => {
        this.$emit('nChange', this.date)
      },500)
    }


}
